export type Variant = { name: string; distribution: number };

export type IAbTest = {
  id: number;
  variants: Variant[];
  title: string;
  description: string;
  cookieName?: string;
  cookieVariants?: string[];
  optimizeExperimentId?: string;
  enabled: boolean;
};

const oneThird = 100 / 3;

/**
 * Definition of available experiments.
 * 
 * When an experiment is set to "enabled: false" it will always return
 * variant 0 and it will not be send to the BusinessLayer analytics in
 * the active experiments.
 */
const experiments = {
  italianCitiesPricing: {
    id: 49,
    title: 'Pricing A/B test for Italian Cities',
    description: 'Goal of test is to find out if our prices are too high for a selection of cities and experiences.',
    variants: [
      { name: 'Regular Price', distribution: 50 },
      { name: 'Modified Price', distribution: 50 },
    ],
    cookieName: 'dynamic-price-italian-test',
    cookieVariants: ['RegularPrice', 'ModifiedPrice'],
    enabled: false,
  },
  overviewPage: {
    id: 40,
    title: 'AB test for Overview Page',
    description: 'When ALL search mode selected go to /overview page instead of /s',
    variants: [
      { name: 'search results', distribution: 50 },
      { name: 'overview page', distribution: 50 },
    ],
    enabled: true,
  },
  localPicker: {
    id: 47,
    title: 'AB test for local picker',
    description: 'This will show or hide the localpicker feature depending on the variant',
    variants: [
      { name: 'with localpicker', distribution: 50 },
      { name: 'without localpicker', distribution: 50 },
    ],
    enabled: false,
  },
  roundedPriceCards: {
    id: 50,
    title: 'Round prices in experience cards',
    description: 'This will test if rounding the prices in experience cards will increase conversion',
    variants: [
      { name: 'without rounding', distribution: 50 }, // old
      { name: 'with rounding', distribution: 50 } // new
    ],
    enabled: false
  },
  productPageDescription: {
    id: 51,
    title: 'Product page description test',
    description: 'This will test different variations of the product page description',
    variants: [
      { name: 'oldText', distribution: oneThird },
      { name: 'oldTextExpanded', distribution: oneThird },
      { name: 'newTextSectionsExpanded', distribution: oneThird },
    ],
    enabled: true
  },
};

export type AbTestName = keyof typeof experiments;

export function getExperimentByName(experimentName: AbTestName): IAbTest | undefined {
  return experiments[experimentName];
}

export function getExperimentById(experimentId: number): IAbTest | undefined {
  return Object.values(experiments).find(experiment => experiment.id === experimentId);
}

export function getAllExperiments(): IAbTest[] {
  return Object.values(experiments);
}

